import $ from 'jquery';

require('imports!jqueryvalidate/jquery.validate-1.11.1.js');

function addDateValidation() {
	// CHECKBOX must be true
	$.validator.addMethod(
		'required_group',
		(value, element) => {
			// var $module = $(element).parents('form');
			// recupero il messaggio impostato nel model tramite l'annotation [required]
			const checkCustomError = $(element).data('val-required');
			$.validator.messages.required_group = checkCustomError;
			return $(element).prop('checked');
		}, '');

	$.validator.addClassRules('required-checkbox', { required_group: true });
	// /CHECKBOX

	// DATE
	const $dateElements = $('.ui-date-picker');
	if ($dateElements !== undefined && $dateElements.length > 0) {
		// $dateElements.datepicker({dateFormat: 'dd/mm/yy'});

		$.validator.addMethod(
			'date',
			function validateDate(value, element) {
				// console.log('validate date with value:' + value);
				if (this.optional(element)) {
					return true;
				}
				let result = false;
				try {
					$.datepicker.parseDate('dd/mm/yy', value);
					result = true;
				} catch (err) {
					result = false;
				}
				return result;
			},
			''
		);
	}

		// /DATE

	// DATETIME
	const $datetimeElements = $('.ui-datetime-picker');
	if ($datetimeElements !== undefined && $datetimeElements.length > 0) {
		// $datetimeElements.datepicker({dateFormat: 'dd-mm-yy'});
		$.validator.addMethod(
			'datetime',
			function validateDateTime(value, element) {
				if (this.optional(element)) {
					return true;
				}
				let result = false;
				try {
					$.datepicker.parseDate('yy-mm-dd', value);
					result = true;
				} catch (err) {
					result = false;
				}
				return result;
			},
			''
		);
	}
}

module.exports = addDateValidation;



// WEBPACK FOOTER //
// ./Scripts/libs/common/jquery.validate.directio.js